const LANDING_PLAN_FALLBACK = [
  {
    productId: 'basic-pack',
    title: 'Basic Pack',
    tagline: 'The clean starting point.',
    description: 'Perfect for individuals or light users getting started with Generative AI.',
    priceText: '฿319.93 / month',
    billingText: '(Billed annually at ฿3,839.16)',
    saveText: '',
    badge: '',
    bestFor: 'trying things out & waking up your creativity',
    theme: 'lilac',
    buttonLabel: 'Select Plan',
    displayOrder: 1,
    creditsPerYear: 1500,
    bonusCredits: 0,
    totalCredits: 1500,
    features: [
      '1,500 credits per year',
      '0 bonus credits',
      '1,500 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    productId: 'create-pack',
    title: 'Create Pack',
    tagline: 'More room to explore.',
    description: 'Designed for growing creators who need more flexibility.',
    priceText: '฿1,068.93 / month',
    billingText: '(Billed annually at ฿12,827.16)',
    saveText: '+250 bonus credits',
    badge: '',
    bestFor: 'creators who are getting serious',
    theme: 'lilac',
    buttonLabel: 'Select Plan',
    displayOrder: 2,
    creditsPerYear: 5250,
    bonusCredits: 250,
    totalCredits: 5500,
    features: [
      '5,250 credits per year',
      '250 bonus credits',
      '5,500 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    productId: 'studio-pack',
    title: 'Studio Pack',
    tagline: 'Steady output for active creators.',
    description: 'Built for small teams and active creators.',
    priceText: '฿1,594.30 / month',
    billingText: '(Billed annually at ฿19,131.60)',
    saveText: '+750 bonus credits',
    badge: '',
    bestFor: 'consistent production and regular campaign work',
    theme: 'violet',
    buttonLabel: 'Select Plan',
    displayOrder: 3,
    creditsPerYear: 8200,
    bonusCredits: 750,
    totalCredits: 8950,
    features: [
      '8,200 credits per year',
      '750 bonus credits',
      '8,950 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    productId: 'master-pack',
    title: 'Master Pack',
    tagline: 'Balanced for serious output.',
    description: 'Our most popular choice for professionals and businesses.',
    priceText: '฿4,269.30 / month',
    billingText: '(Billed annually at ฿51,231.60)',
    saveText: '+2,550 bonus credits',
    badge: 'Most Popular',
    bestFor: 'professionals balancing cost and performance',
    theme: 'violet',
    buttonLabel: 'Select Plan',
    displayOrder: 4,
    creditsPerYear: 22500,
    bonusCredits: 2550,
    totalCredits: 25050,
    features: [
      '22,500 credits per year',
      '2,550 bonus credits',
      '25,050 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    productId: 'creator-plus-pack',
    title: 'Creator+ Pack',
    tagline: 'Built for teams with demand.',
    description: 'For advanced creators and creative teams with high demands.',
    priceText: '฿10,593.00 / month',
    billingText: '(Billed annually at ฿127,116.00)',
    saveText: '+7,500 bonus credits',
    badge: '',
    bestFor: 'agencies, content teams, and brand production',
    theme: 'orange',
    buttonLabel: 'Select Plan',
    displayOrder: 5,
    creditsPerYear: 57000,
    bonusCredits: 7500,
    totalCredits: 64500,
    features: [
      '57,000 credits per year',
      '7,500 bonus credits',
      '64,500 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    productId: 'production-pack',
    title: 'Production Pack',
    tagline: 'For continuous large-scale output.',
    description: 'Optimized for heavy production environments.',
    priceText: '฿17,013.00 / month',
    billingText: '(Billed annually at ฿204,156.00)',
    saveText: '+14,500 bonus credits',
    badge: '',
    bestFor: 'businesses running large-scale content operations',
    theme: 'orange',
    buttonLabel: 'Select Plan',
    displayOrder: 6,
    creditsPerYear: 94000,
    bonusCredits: 14500,
    totalCredits: 108500,
    features: [
      '94,000 credits per year',
      '14,500 bonus credits',
      '108,500 total credits',
      'Top up after all credits are used',
    ],
  },
  {
    productId: 'infinity-pack',
    title: 'Infinity Pack',
    tagline: 'The biggest yearly credit pool.',
    description: 'Maximum power for enterprise-level visual generation.',
    priceText: '฿27,713.00 / month',
    billingText: '(Billed annually at ฿332,556.00)',
    saveText: '+25,900 bonus credits',
    badge: 'Best Value',
    bestFor: 'organizations requiring massive ongoing generation',
    theme: 'orange',
    buttonLabel: 'Select Plan',
    displayOrder: 7,
    creditsPerYear: 155400,
    bonusCredits: 25900,
    totalCredits: 181300,
    features: [
      '155,400 credits per year',
      '25,900 bonus credits',
      '181,300 total credits',
      'Top up after all credits are used',
    ],
  },
];

export default LANDING_PLAN_FALLBACK;
